export default __webpack_public_path__ + "static/media/check-circle.fc206c2b.svg";